const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || 'http://localhost:8000';

export const razorpayService = {
  // Create a Razorpay order with production-ready error handling
  async createOrder(amount, currency = 'INR', receipt = null, notes = {}) {
    try {
      const response = await fetch(`${BACKEND_URL}/api/create-razorpay-order`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          amount,
          currency,
          receipt: receipt || `receipt_${Date.now()}`,
          notes
        }),
      });

      if (!response.ok) {
        const errorData = await response.json().catch(() => ({}));
        throw new Error(errorData.message || `HTTP error! status: ${response.status}`);
      }

      const data = await response.json();
      return data;
    } catch (error) {
      // Production: Enhanced error handling
      if (error.name === 'TypeError' && error.message.includes('fetch')) {
        throw new Error('Network error. Please check your connection.');
      }
      throw error;
    }
  },

  // Verify Razorpay payment
  async verifyPayment(razorpayOrderId, razorpayPaymentId, razorpaySignature) {
    try {
      const response = await fetch(`${BACKEND_URL}/api/verify-razorpay-payment`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          razorpay_order_id: razorpayOrderId,
          razorpay_payment_id: razorpayPaymentId,
          razorpay_signature: razorpaySignature
        }),
      });

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const data = await response.json();
      return data;
    } catch (error) {
      throw error;
    }
  },

  // Initialize Razorpay checkout
  initializeRazorpayCheckout(orderId, amount, currency = 'INR', options = {}) {
    return new Promise((resolve, reject) => {
      // Load Razorpay script if not already loaded
      if (window.Razorpay) {
        this.openRazorpayCheckout(orderId, amount, currency, options, resolve, reject);
      } else {
        const script = document.createElement('script');
        script.src = 'https://checkout.razorpay.com/v1/checkout.js';
        script.async = true;
        
        script.onload = () => {
          this.openRazorpayCheckout(orderId, amount, currency, options, resolve, reject);
        };
        
        script.onerror = () => {
          reject(new Error('Failed to load Razorpay script'));
        };
        
        document.body.appendChild(script);
      }
    });
  },

  // Open Razorpay checkout
  openRazorpayCheckout(orderId, amount, currency, options, resolve, reject) {
    const defaultOptions = {
      key: process.env.REACT_APP_RAZORPAY_KEY_ID || 'rzp_test_your_test_key_here',
      amount: Math.round(amount * 100), // Convert to paise
      currency,
      name: 'Fijoli Book',
      description: options.description || 'Online Book Access',
      image: '/logo192.png',
      order_id: orderId,
      handler: function (response) {
        resolve(response);
      },
      prefill: {
        name: options.customerName || 'Reader',
        email: options.customerEmail || 'reader@example.com',
        contact: options.customerPhone || '9999999999'
      },
      theme: {
        color: options.themeColor || '#DC2626'
      },
      modal: {
        ondismiss: function() {
          reject(new Error('Payment cancelled by user'));
        }
      }
    };

    const rzp = new window.Razorpay(defaultOptions);
    rzp.open();
  }
};

export default razorpayService;
